import { render, staticRenderFns } from "./EditLiveEditStageTab.vue?vue&type=template&id=856273d2"
import script from "./EditLiveEditStageTab.vue?vue&type=script&lang=js"
export * from "./EditLiveEditStageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports